import * as React from "react";
import { inject, observer } from "mobx-react";
import ModelStore from "src/stores/ModelStore";

interface IProps {
  modelStore?: ModelStore;
}
@inject("modelStore")
@observer
export default class InfoBox extends React.Component<IProps,{}>  {

  public render(){
        return (
            <div className="info-box">
              { this._renderSubItems() }
            </div>
        );
        
  }

  private _renderSubItems():React.ReactNode[]{
    const modelStore = this.props.modelStore as ModelStore;
    const items:any[] = [];
    if(modelStore.selectedProduct!==null){
        items.push(<div key='product'><strong>Produkt:</strong> { modelStore.selectedProduct }</div>);
    } 
    if(modelStore.selectedModel!==null){
      items.push(<div key='form'><strong>Form:</strong> { modelStore.selectedModel.title }</div>);

      if(modelStore.selectedInlay!==null){
        items.push(<div key='inlay'><strong>Inlay:</strong> { modelStore.selectedInlay.title }</div>);
      } 
      if(modelStore.selectedPrintColors!==null){
        items.push(<div key='print'><strong>Druck:</strong> { modelStore.selectedPrintColors.split(',').join(', ') }</div>);
      } 
      if(modelStore.selectedRefinements!==null){
        items.push(<div key='refinement'><strong>Veredelung:</strong> { modelStore.selectedRefinements.split(',').join(', ')}</div>);
      } 


    } 
    return items;
  }
}


// WEBPACK FOOTER //
// ./src/components/InfoBox.tsx